import Joyride from "react-joyride";
import { CustomTourTooltip } from "./CustomTourToolTip";

export const JoyrideWrapper = ({run, steps, setter, end, featureName, p_name, controls = true})=>{

    const CustomTooltip = ({ step, primaryProps, skipProps, backProps, tooltipProps, size, index}) => (
        <CustomTourTooltip end={end} featureName={featureName} p_name={p_name} step={step} primaryProps={primaryProps} skipProps={skipProps} backProps={backProps} tooltipProps={tooltipProps} size={size} index={index} setter={setter} controls={controls}/>
    ); 

    return(
        <Joyride
            continuous
            disableOverlayClose={true} 
            run={run}
            steps={steps}
            hideCloseButton
            showSkipButton={false}
            showProgress
            tooltipComponent={CustomTooltip}
            callback={({ status}) => {
                if (status === 'finished') {
                    setter()
                    end(featureName, p_name)
                }
            }}
            spotlightClicks={true}
            styles={{
                spotlight:{
                    borderRadius: "11px"
                }
            }}
        />
    )
}